import $ from "jquery"
import "jquery-match-height";

$('.js-match-height-solutions-title').matchHeight();
$('.js-match-height-solutions-content').matchHeight();
$('.js-match-height-story-meta').matchHeight();
$('.js-match-height-brands').matchHeight();

$(window).on('resize', function(){
    setTimeout(function(){
        $('.js-match-height-solutions-title').matchHeight();
        $('.js-match-height-solutions-content').matchHeight();
        $('.js-match-height-story-meta').matchHeight();
        $('.js-match-height-brands').matchHeight();
    }, 500);
});